import { selector } from 'lib/selectors';

export const organization = (state) => state.organization;
export const currentOrganizationSelector = selector(organization, (org) => org.currentOrganization);
